<script setup lang="ts">
import { MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';
import { ButtonPrimaryAccented, CheckboxBase, InputMasked, InputOutlined } from '~/features/ui-kit';
import { useSignIn } from '../business/useSignIn';
import { useAuthSDK } from '~/features/auth-sdk';

const { signInFillingProfileStep, goToPhoneStep } = useSignIn();
const { formData, hasChanges, isLoading, handleSubmit } = signInFillingProfileStep;

const { magnitIdCode } = useAuthSDK();
if (!magnitIdCode.value) {
  goToPhoneStep();
}
</script>

<template>
  <MMPopupDefault class="popup">
    <template #header>
      <MMText font="Title L/Semibold" label="Заполните свой профиль" />
    </template>

    <div class="popup-content">
      <InputOutlined
        v-model="formData.name.value"
        placeholder="Введите имя"
        label="Имя"
        is-required
        :absolute-errors="false"
        :error="formData.name.error"
      />

      <InputOutlined
        v-model="formData.email.value"
        placeholder="Введите электронную почту"
        label="Электронная почта"
        is-required
        :absolute-errors="false"
        :error="formData.email.error"
      />

      <InputMasked
        v-model="formData.birthDate.value"
        label="Дата рождения"
        placeholder="ДД-ММ-ГГГГ"
        :error="formData.birthDate.error"
        mask="00-00-0000"
        :absolute-errors="false"
      />

      <CheckboxBase
        v-model="formData.notifications.value"
        class="popup-content__checkbox"
      >
        <MMText font="Body M/Regular" label="Получать информацию об акциях и скидках: через пуш-уведомления, смс, письма и другие способы связи" />
      </CheckboxBase>
    </div>

    <template #footer>
      <ButtonPrimaryAccented w100 size="l48" :disabled="!hasChanges" :loading="isLoading" @click="handleSubmit">
        Сохранить
      </ButtonPrimaryAccented>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.popup
  width 480px
  height 568px

  &__close
    position absolute
    top 24px
    right 22px
    cursor pointer

  +Media(Mobile)
    max-width calc(100vw - 32px)

  &-content
    height 100%
    margin-top 16px
    margin-bottom 24px
    display flex
    flex-direction column
    gap 16px

    &__checkbox
      margin-top auto
</style>